import React from 'react';

interface Props {
  delta: number;
  onDismiss: () => void;
}

const formatRupiah = (n: number): string =>
  'Rp ' + Math.abs(n).toLocaleString('id-ID');

const InvoiceDataChangedToast: React.FC<Props> = ({ delta, onDismiss }) => {
  return (
    <div className="mb-6 flex items-start gap-3 bg-amber-50 border border-amber-300 rounded-xl px-4 py-4 text-sm text-amber-800">
      <i className="ri-alert-line text-amber-500 text-[20px] mt-0.5 shrink-0" />
      <div className="flex-1">
        <p className="font-semibold mb-1">Invoice total has changed since you last reviewed this period.</p>
        <p>
          The period has been reset to <strong>Pending</strong> — please re-verify before
          closing.
          {delta !== 0 && (
            <span className="ml-1">
              (Change: {delta > 0 ? '+' : '-'}{formatRupiah(delta)})
            </span>
          )}
        </p>
      </div>
      <button
        type="button"
        onClick={onDismiss}
        className="text-amber-500 hover:text-amber-700 shrink-0"
        aria-label="Dismiss"
      >
        <i className="ri-close-line text-[18px]" />
      </button>
    </div>
  );
};

export default InvoiceDataChangedToast;
